import React, { useState } from 'react';
import { Equation, Expression, parse } from 'algebra.js';

const EquationSolver = () => {
  const [equation, setEquation] = useState('');
  const [solution, setSolution] = useState('');

  const handleSolve = () => {
    try {
      if (!equation.includes('=')) {
        setSolution('❌ Equation must contain an "=" sign.');
        return;
      }

      const [lhs, rhs] = equation.split('=').map(side => parse(side));
      const eq = new Equation(lhs, rhs);
      const result = eq.solveFor('x');

      setSolution(`✅ Solution: x = ${result.toString()}`);
    } catch (error) {
      setSolution('❌ Invalid equation or unsupported format. Please try again.');
    }
  };

  return (
    <section className="min-h-screen bg-[#02042b] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white/10 backdrop-blur-lg text-white p-8 rounded-2xl shadow-2xl border border-white/20">
        <h1 className="text-3xl font-extrabold mb-6 text-center">Equation Solver</h1>

        <input
          type="text"
          className="w-full p-4 border border-white/20 bg-white/5 text-white placeholder-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          value={equation}
          onChange={(e) => setEquation(e.target.value)}
          placeholder='e.g., x^2 - 4x + 3 = 0'
        />

        <button
          onClick={handleSolve}
          className="mt-6 w-full bg-gradient-to-r from-blue-600 to-teal-500 text-white font-semibold px-6 py-3 rounded-lg hover:scale-105 transition duration-300"
        >
          Solve the Equation
        </button>

        {solution && (
          <div className="mt-6 p-4 bg-white/10 rounded-lg border border-white/20 text-green-300 font-medium">
            {solution}
          </div>
        )}
      </div>
    </section>
  );
};

export default EquationSolver;
